import { SessionDetailsSummary } from "components/SessionDetailsSummary";
import clsx from "clsx";
import { memo, ReactNode } from "react";
import { ReactComponent as MenuIcon } from "assets/menu.svg";
import { ReactComponent as ToolsForHumanityLogo } from "assets/Tools_for_Humanity_logo.svg";
import { usePrivacyModalFull } from "hooks/usePrivacyModalFull";
import { getUserEmail } from "lib/get-user-email";

type LayoutProps = {
  children?: ReactNode;
  className?: string;
  toolbar?: ReactNode;
  toolbarClassName?: string;
  wrapperClassName?: string;
  showTitle?: boolean;
  showPrivacyModal?: boolean;
};

export const Layout = memo(function Layout(props: LayoutProps) {
  const privacyModalFull = usePrivacyModalFull();

  return (
    <>
      {privacyModalFull.modal}
      <div
        className={clsx(
          "relative grid h-screen-safe gt-phone:h-[min(100vh,_896px)]",
          {
            "grid-rows-[auto_1fr_auto]":
              (props.showTitle || props.showPrivacyModal) && props.toolbar,
            "grid-rows-[auto_1fr]":
              (props.showTitle || props.showPrivacyModal) && !props.toolbar,
            "grid-rows-[1fr_auto]":
              props.toolbar && !(props.showTitle || props.showPrivacyModal),
          },
          props.wrapperClassName
        )}
      >
        {(props.showTitle || props.showPrivacyModal) && (
          <div className="sticky top-0 inset-x-0 flex items-center justify-between py-3 px-5">
            {props.showTitle && (
              <div className="flex items-center gap-3">
                <ToolsForHumanityLogo className="w-6 h-6 flex-shrink-0" />
                <span className="text-base font-bold leading-tight break-words max-w-[50vw]">
                  {getUserEmail().split("@")[0]}
                </span>
              </div>
            )}

            {props.showPrivacyModal && (
              <MenuIcon onClick={() => privacyModalFull.showModal()} />
            )}
          </div>
        )}

        <div
          className={clsx(
            "px-5 pb-6 overflow-y-auto pt-4 md:pt-8",
            props.className
          )}
        >
          <SessionDetailsSummary />
          {props.children}
        </div>

        {props.toolbar && (
          <div
            className={clsx(
              "sticky bottom-0 inset-x-0 px-5 py-3 md:py-6 grid gap-y-2",
              "border-t border-f4f7ff shadow-[0_-4px_12px_rgba(0,0,0,0.05)]",
              props.toolbarClassName
            )}
          >
            {props.toolbar}
          </div>
        )}
      </div>
    </>
  );
});
